var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import TdInner from './TdInner';
import { HeaderContext } from '../utils/tableContext';
function Td(props) {
    var context = useContext(HeaderContext);
    if (!context) {
        throw new Error('Td must be used as a child of the Table component');
    }
    var headers = context.headers;
    return React.createElement(TdInner, __assign({}, props, { headers: headers }));
}
export default Td;
